import { ContentContext, CountryContext, LocaleContext } from 'Components/hooks/context';
import React, { useContext } from 'react';

import AsideBox from 'Components/common/AsideBox';
import AtlasMetadataClient from '@reuters-graphics/graphics-atlas-client';
import CountryCompare from './CountryCompare';
import CountryReferrals from './CountryReferrals';
import DailyCountsTwoPack from 'Components/common/DailyCountsTwoPack';
import Headline from './Headline';
import Interstitial from './Interstitial';
import LocaleLinks from './LocaleLinks';
import LockdownTimeline from './LockdownTimeline';
import MethodologyLink from 'Components/common/MethodologyLink';
import ReutersReferrals from 'Components/common/ReutersReferrals';
import SmartText from '@reuters-graphics/react-smart-text';
// import Testing from './Testing';
import Vaccination from './Vaccination';
import useGetCSV from 'Components/hooks/getCSV';

const atlas = new AtlasMetadataClient();

const PageContent = (props) => {
  const { nationalCounts, globalStatistics, locales, oxfordStringency } = props;

  const content = useContext(ContentContext);
  const countrySlug = useContext(CountryContext);
  const locale = useContext(LocaleContext);

  useGetCSV(countrySlug);

  const country = atlas.getCountry(countrySlug);

  const sources = nationalCounts.sources ? nationalCounts.sources.map(({ link, name }) => (
    <li key={link}>
      <a href={link} target='_blank' rel='noreferrer' className='spaced-link'>{name}</a>
    </li>
  )) : null;

  return (
    <article>
      <section>
        <LocaleLinks locales={locales} />
      </section>
      <section className=''>
        <Headline
          globalStatistics={globalStatistics}
          caseCounts={nationalCounts.cases}
          warning={nationalCounts.warning}
        />
      </section>
      <section>
        <DailyCountsTwoPack counts={nationalCounts} />
        <div className='section-spacer' />
      </section>

      {(country.dataProfile && country.dataProfile.population) && (<Vaccination
        hasData={props.hasData.vaccination}
        caseCounts={nationalCounts.cases}
        hasPopData={country.dataProfile && country.dataProfile.population}
      />)}

      {/* <Testing
        hasData={props.hasData.testing}
        caseCounts={nationalCounts.cases}
      /> */}

      <Interstitial />

      <section className=''>
        {oxfordStringency && (
          <LockdownTimeline
            caseCounts={nationalCounts.cases}
            lockdownData={oxfordStringency}
          />
        )}
      </section>

      <section>
        <CountryCompare globalStatistics={globalStatistics} />
      </section>
      <section className=''>
        <CountryReferrals globalStatistics={globalStatistics} />
      </section>
      <section className='wide'>
        <AsideBox
          title={content.common.about.title}
          source={content.common.about.smarttext}
          context={{ countries: Object.keys(globalStatistics.latestTotals.cases).length }}
        >
          <p className='readmore-link'><MethodologyLink>{content.common.about.methodologyLink}</MethodologyLink></p>
          {(nationalCounts.note && nationalCounts.note[locale]) && (
            <>
              <div className='section-spacer-internal' />
              <h4>
                <SmartText
                  source={content.template.about.notes.title}
                  context={{ country: country.translations[locale] }}
                />
              </h4>
              <SmartText
                source={nationalCounts.note[locale]}
                wrap
              />
            </>
          )}
          {sources && (
            <>
              <div className='section-spacer-internal' />
              <h4>
                <SmartText
                  source={content.template.about.sources.title}
                  context={{ country: country.translations[locale] }}
                />
              </h4>
              <ul className='sources-list'>{sources}</ul>
            </>
          )}
        </AsideBox>
      </section>
      <section className=''>
        <div className='col-12 col-lg-10 mx-auto px-0 country-page'>
          <ReutersReferrals />
        </div>
      </section>
    </article>
  );
};

export default PageContent;
